import React from 'lib/react';
import clsx from 'lib/clsx';
import { useTranslation } from 'lib/translation';
import { EVAlert, EVTypography, EVCheckCircleOutlineIcon } from 'lib/components';
import { SUCCESS } from 'constants/AppConstants';
import OrderStyles from 'features/order/OrderStyles';
import { srsBranchEmployeeMessageReset } from 'features/order/Order.actions';
import { useDispatch } from 'lib/redux';

function SRSValidationBannerSuccessComponent() {
  const classes = OrderStyles();
  const { t } = useTranslation();

  const dispatch = useDispatch();

  const onClose = () => dispatch(srsBranchEmployeeMessageReset());

  return (
    <EVAlert
      severity={SUCCESS}
      onClose={onClose}
      className={classes.srsalert}
      classes={{
        icon: classes.srssuccessAlertIcon,
        message: classes.srsalertMsg,
        root: classes.successAlert,
        action: clsx(classes.closeBtn, classes.srssuccessAlertIcons),
      }}
      iconMapping={{ success: <EVCheckCircleOutlineIcon /> }}
    >
      <EVTypography className="title">{t('order__report_srs_validation_success_banner')}</EVTypography>
    </EVAlert>
  );
}

export default SRSValidationBannerSuccessComponent;
